import { Button, Form, Input, Modal, Select } from "antd";
import { useEffect, useRef, useState } from "react";
import CommonInput from "../../../../Common/CommonInput";
import {
  creditCardValidation,
  dispatchtoast,
  filterOption,
  getLocalStorageItem,
  ifscPattern,
  mobilePattern,
} from "../../../../Utils";
import {
  getPayFusionBanks,
  PayFusionCreditCardBill,
} from "../../../../ApiServices/Apifun";
import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../../Store/B2bslice";

const CreditCardPayFusion = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [creditCardbanks, setcreditCardbanks] = useState([]);
  const formref = useRef();

  const handleGetbank = () => {
    getPayFusionBanks()
      .then((res) => {
        setcreditCardbanks(
          res.banks.map((i) => {
            return {
              label: i?.bankName,

              value: i?.id,
              key: i?.ifscCode ? i.ifscCode : "",
            };
          }),
        );
      })
      .catch((err) => console.log(err));
  };
  const handlefillIFSC = (val) => {
    formref.current.setFieldsValue({
      ifsc: val.key,
    });
  };
  useEffect(() => {
    handleGetbank();
    dispatch(setselectedTab("300.11"));
  }, []);

  const handleVerify = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("bank_id", val.bank_id?.value);
    formdata.append("bank_name", val.bank_id?.label);
    formdata.append("bank_ifsc", val.bank_id?.key);
    formdata.append("amount", val.amount);
    formdata.append("card_number", val.card_number);
    formdata.append("card_holder_name", val.card_holder_name);
    formdata.append("customer_mobile", val.customer_mobile);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));

    PayFusionCreditCardBill(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setBtnLoading(false);
        form.resetFields();
      });
  };
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2"> Credit Card</p>
          <Form
            name="form"
            form={form}
            ref={formref}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleVerify(val)}
          >
            <Form.Item
              name={`bank_id`}
              label={"Select Bank"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select One Bank!",
                },
              ]}
            >
              <Select
                placeholder="Select Bank"
                // loading={selectLoading}
                filterOption={filterOption}
                showSearch={true}
                labelInValue
                onChange={(val) => handlefillIFSC(val)}
                className="w-full"
                options={creditCardbanks}
              />
            </Form.Item>
            <Form.Item
              name={`ifsc`}
              label={"IFSC"}
              className="col-span-2"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter IFSC Code!",
                },
                {
                  pattern: ifscPattern,
                  message: "Invalid ifsc number format!",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.toUpperCase();
                  e.target.value = value;
                }}
                placeholder="Enter IFSC Code"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`card_number`}
              label={"Card Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Card Number!",
                },
                {
                  pattern: creditCardValidation,
                  message: "Enter valid Card Number!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.toUpperCase();
                  e.target.value = value;
                }}
                placeholder="Enter IFSC"
                name="benificiary_ifsc"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`customer_mobile`}
              label={"Mobile No."}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Please enter mobile number",
                },
                {
                  pattern: mobilePattern,
                  message: "Mobile number must be a valid 10-digit number",
                },
                {
                  whitespace: true,
                  message: "Mobile number cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Mobile No"
                name="amount"
              />
            </Form.Item>
            <Form.Item
              name={`card_holder_name`}
              label={"Card Holder Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Card Holder Name!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Benificiary Name"
                name="benificiary_name"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`amount`}
              label={"Amount"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Amount!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Amount"
                name="amount"
              />
            </Form.Item>
            <Button
              loading={btnLoading}
              className="w-full bg-primary border-none mt-4"
              style={{ color: "white" }}
              htmlType="submit"
            >
              Pay
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default CreditCardPayFusion;
